if (!$('#uber').hasClass('moduleInterior')) {
    if (iCreateObject.isSiteInICreateMode) {

        var toggleHtmlStructure = '<div class="toggleContent cf">';

        //if ($("#contactMainContainer").length > 0) {
        //    toggleHtmlStructure += "<label for=\"chkHideRightContact\" class=\"ic-checkbox-inline\">";
        //    toggleHtmlStructure += "<input id=\"chkHideRightContact\" type=\"checkbox\" name=\"chkHideRightContact\" />Hide Contact</label>";
        //}

        if ($('.noticeBar').length > 0) {
            toggleHtmlStructure += '<label for="chkHideNoticeBar" class="ic-checkbox-inline">';
            toggleHtmlStructure += '<input id="chkHideNoticeBar" type="checkbox" name="chkHideNoticeBar" />Hide Notice Bar</label>';
        }
        if ($('.newsFeed').length > 0) {
            toggleHtmlStructure += '<label for="chkHideNewsFeed" class="ic-checkbox-inline">';
            toggleHtmlStructure += '<input id="chkHideNewsFeed" type="checkbox" name="chkHideNewsFeed" />Hide News Feed</label>';
        }
        if ($('.eventsFeed').length > 0) {
            toggleHtmlStructure += '<label for="chkHideEventsFeed" class="ic-checkbox-inline">';
            toggleHtmlStructure += '<input id="chkHideEventsFeed" type="checkbox" name="chkHideEventsFeed" />Hide Events Feed</label>';
        }
        if ($('.storyFeature').length > 0) {
            toggleHtmlStructure += '<label for="chkHideStoryFeatures" class="ic-checkbox-inline">';
            toggleHtmlStructure += '<input id="chkHideStoryFeatures" type="checkbox" name="chkHideStoryFeatures" />Hide Story Features</label>';
        }
        if ($('.socialMedia').length > 0) {
            toggleHtmlStructure += '<label for="chkHideSocialFeeds" class="ic-checkbox-inline">';
            toggleHtmlStructure += '<input id="chkHideSocialFeeds" type="checkbox" name="chkHideSocialFeeds" />Hide Social Feed</label>';
        }
        if ($('.videoSlider').length > 0) {
            toggleHtmlStructure += '<label for="chkHideVideoCarousel" class="ic-checkbox-inline">';
            toggleHtmlStructure += '<input id="chkHideVideoCarousel" type="checkbox" name="chkHideVideoCarousel" />Hide Video Carousel</label>';
        }

        toggleHtmlStructure += '<label for="chkHideEmergencyAlert" class="ic-checkbox-inline">';
        toggleHtmlStructure += '<input id="chkHideEmergencyAlert" type="checkbox" name="chkHideEmergencyAlert" />Hide Emergency Alert</label>';

        toggleHtmlStructure += '</div>';

        $('#uberMain').before(toggleHtmlStructure);
    }

    if ($('#TKInteriorHideAreasToggle #frmToggleContent').length <= 0) {
        var myForm = $('<form>');
        myForm.attr({ 'id': 'frmToggleContent', 'action': '#' });

        //if ($("#contactMainContainer").length > 0) {
        //    myForm.append($("<input>").attr({ "type": "hidden", "id": "hdnHideRightContact", "value": $("#contactMainContainer").hasClass("hide") ? "hide" : "" }))
        //}

        if ($(".noticeBar").length > 0) {
            myForm.append($("<input>").attr({ 'type': 'hidden', 'id': 'hdnHideNotcieBar', 'value': $('.noticeBar').hasClass('hide') ? 'hide' : '' }))
        }
        if ($(".newsFeed").length > 0) {
            myForm.append($("<input>").attr({ 'type': 'hidden', 'id': 'hdnHideNewsFeed', 'value': $('.newsFeed').hasClass('hide') ? 'hide' : '' }))
        }
        if ($(".eventsFeed").length > 0) {
            myForm.append($("<input>").attr({ 'type': 'hidden', 'id': 'hdnHideEventsFeed', 'value': $('.eventsFeed').hasClass('hide') ? 'hide' : '' }))
        }
        if ($(".storyFeature").length > 0) {
            myForm.append($("<input>").attr({ 'type': 'hidden', 'id': 'hdnHideStoryFeatures', 'value': $('.storyFeature').hasClass('hide') ? 'hide' : '' }))
        }
        if ($(".socialMedia").length > 0) {
            myForm.append($("<input>").attr({ 'type': 'hidden', 'id': 'hdnHideSocialFeeds', 'value': $('.socialMedia').hasClass('hide') ? 'hide' : '' }))
        }
        if ($(".videoSlider").length > 0) {
            myForm.append($("<input>").attr({ 'type': 'hidden', 'id': 'hdnHideVideoCarousel', 'value': $('.videoSlider').hasClass('hide') ? 'hide' : '' }))
        }


        myForm.append($('<input>').attr({ 'type': 'hidden', 'id': 'hdnHideEmergencyAlert', 'value': '' }));
        myForm.append($('<input>').attr({ 'type': 'submit', 'id': 'btnToggleContent', 'name': 'btnToggleContent', 'aria-label': 'Toggle Content' }).addClass('hideButton'));

        $('#TKInteriorHideAreasToggle').empty().append(myForm);
    } else {
        //Insert emergency alert banner if not already there
        if ($('#TKInteriorHideAreasToggle #frmToggleContent #hdnHideEmergencyAlert').length <= 0) {
            $('#TKInteriorHideAreasToggle #frmToggleContent').prepend($('<input>').attr({ 'type': 'hidden', 'id': 'hdnHideEmergencyAlert', 'value': '' }));
        }
    }


    // bind checkbox with hidden fields
    if (($('#hdnHideEmergencyAlert').length > 0) && ($('#hdnHideEmergencyAlert').val() === 'hide')) {
        if ($('#chkHideEmergencyAlert').length > 0) {
            $('#chkHideEmergencyAlert').attr('checked', 'checked');
        }
    }

    if (($('#hdnHideNotcieBar').length > 0) && ($('#hdnHideNotcieBar').val() === 'hide')) {
        if ($('#chkHideNoticeBar').length > 0) {
            $('#chkHideNoticeBar').attr('checked', 'checked');
        }
        $('.noticeBar').toggleClass('hide', true);
    } else if (($('#hdnHideNotcieBar').length > 0) && ($('#hdnHideNotcieBar').val() === '')) {
        $('.noticeBar').toggleClass('hide', false);
    }
    //newsfeed
    if (($('#hdnHideNewsFeed').length > 0) && ($('#hdnHideNewsFeed').val() === 'hide')) {
        if ($('#chkHideNewsFeed').length > 0) {
            $('#chkHideNewsFeed').attr('checked', 'checked');
        }
        $('.newsFeed').toggleClass('hide', true);
    } else if (($('#hdnHideNewsFeed').length > 0) && ($('#hdnHideNewsFeed').val() === '')) {
        $('.newsFeed').toggleClass('hide', false);
    }
    //events Feed
    if (($('#hdnHideEventsFeed').length > 0) && ($('#hdnHideEventsFeed').val() === 'hide')) {
        if ($('#chkHideEventsFeed').length > 0) {
            $('#chkHideEventsFeed').attr('checked', 'checked');
        }
        $('.eventsFeed').toggleClass('hide', true);
    } else if (($('#hdnHideEventsFeed').length > 0) && ($('#hdnHideEventsFeed').val() === '')) {
        $('.eventsFeed').toggleClass('hide', false);
    }
    // StoryFeature
    if (($('#hdnHideStoryFeatures').length > 0) && ($('#hdnHideStoryFeatures').val() === 'hide')) {
        if ($('#chkHideStoryFeatures').length > 0) {
            $('#chkHideStoryFeatures').attr('checked', 'checked');
        }
        $('.storyFeature').toggleClass('hide', true);
    } else if (($('#hdnHideStoryFeatures').length > 0) && ($('#hdnHideStoryFeatures').val() === '')) {
        $('.storyFeature').toggleClass('hide', false);
    }

    // Social Feed
    if (($('#hdnHideSocialFeeds').length > 0) && ($('#hdnHideSocialFeeds').val() === 'hide')) {
        if ($('#chkHideSocialFeeds').length > 0) {
            $('#chkHideSocialFeeds').attr('checked', 'checked');
        }
        $('.socialMedia').toggleClass('hide', true);
    } else if (($('#hdnHideSocialFeeds').length > 0) && ($('#hdnHideSocialFeeds').val() === '')) {
        $('.socialMedia').toggleClass('hide', false);
    }

    //Video Carousel
    if (($('#hdnHideVideoCarousel').length > 0) && ($('#hdnHideVideoCarousel').val() === 'hide')) {
        if ($('#chkHideVideoCarousel').length > 0) {
            $('#chkHideVideoCarousel').attr('checked', 'checked');
        }
        $('.videoSlider').toggleClass('hide', true);
    } else if (($('#hdnHideVideoCarousel').length > 0) && ($('#hdnHideVideoCarousel').val() === '')) {
        $('.videoSlider').toggleClass('hide', false);
    }

    // bind checkbox change event
    if ($('#chkHideEmergencyAlert').length > 0) {
        $('#chkHideEmergencyAlert').change(function () {
            $('#hdnHideEmergencyAlert').val($('#chkHideEmergencyAlert:checked').length > 0 ? 'hide' : '');
            if (iCreateObject.isSiteInICreateMode) { $('#TKInteriorHideAreasToggle').save(); }
        });
    }

    if ($('#chkHideNoticeBar').length > 0) {
        $('#chkHideNoticeBar').change(function () {
            $('.noticeBar').toggleClass('hide', $(this).is(':checked'));
            $('#hdnHideNotcieBar').val($('.noticeBar').hasClass('hide') ? 'hide' : '');
            if (iCreateObject.isSiteInICreateMode) { $('#TKInteriorHideAreasToggle').save(); }
        });
    }

    if ($('#chkHideNewsFeed').length > 0) {
        $('#chkHideNewsFeed').change(function () {
            $('.newsFeed').toggleClass('hide', $(this).is(':checked'));
            $('#hdnHideNewsFeed').val($('.newsFeed').hasClass('hide') ? 'hide' : '');
            if (iCreateObject.isSiteInICreateMode) { $('#TKInteriorHideAreasToggle').save(); }
        });
    }
    if ($('#chkHideEventsFeed').length > 0) {
        $('#chkHideEventsFeed').change(function () {
            $('.eventsFeed').toggleClass('hide', $(this).is(':checked'));
            $('#hdnHideEventsFeed').val($('.eventsFeed').hasClass('hide') ? 'hide' : '');
            if (iCreateObject.isSiteInICreateMode) { $('#TKInteriorHideAreasToggle').save(); }
        });
    }
    if ($('#chkHideStoryFeatures').length > 0) {
        $('#chkHideStoryFeatures').change(function () {
            $('.storyFeature').toggleClass('hide', $(this).is(':checked'));
            $('#hdnHideStoryFeatures').val($('.storyFeature').hasClass('hide') ? 'hide' : '');
            if (iCreateObject.isSiteInICreateMode) { $('#TKInteriorHideAreasToggle').save(); }
        });
    }
    if ($('#chkHideSocialFeeds').length > 0) {
        $('#chkHideSocialFeeds').change(function () {
            $('.socialMedia').toggleClass('hide', $(this).is(':checked'));
            $('#hdnHideSocialFeeds').val($('.socialMedia').hasClass('hide') ? 'hide' : '');
            if (iCreateObject.isSiteInICreateMode) { $('#TKInteriorHideAreasToggle').save(); }
        });
    }
    if ($('#chkHideVideoCarousel').length > 0) {
        $('#chkHideVideoCarousel').change(function () {
            $('.videoSlider').toggleClass('hide', $(this).is(':checked'));
            $('#hdnHideVideoCarousel').val($('.videoSlider').hasClass('hide') ? 'hide' : '');
            if (iCreateObject.isSiteInICreateMode) { $('#TKInteriorHideAreasToggle').save(); }
        });
    }
}
